/** @format */

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ADMINISTRATION_FUNCTIONS } from 'src/constants';
import Breadcrumb from 'src/components/Breadcrumb';
import Page from 'src/components/Page';
import { getContentItems, getTopicTree } from 'src/slices/topics';
import { useDispatch, useSelector } from 'src/store';
import { collectUniqueTagLabels, countTopicTreeNodes } from 'src/utils/administration';
import { TopicsIcon, TagsIcon } from 'src/components/icons';

export default function AdministrationPage() {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const { topicTree, topicTreeLoading, contentItems, contentItemsLoading } = useSelector(state => state.topics);

  useEffect(() => {
    const lang = typeof i18n.language === 'string' && i18n.language.trim() ? i18n.language : 'en';
    dispatch(getTopicTree());
  }, [dispatch, i18n.language]);

  useEffect(() => {
    if (!ADMINISTRATION_FUNCTIONS.TAGS) return;
    dispatch(
      getContentItems({
        activeTopicBrand: 'all',
        selectedLanguage: 'Select Language',
        selectedSortBy: 'Sort by'
      })
    );
  }, [dispatch]);

  const hasTopicTreeData = topicTree !== null;
  const topicsCount = hasTopicTreeData ? countTopicTreeNodes(topicTree) : '—';
  const shouldDimTopicsCount = topicTreeLoading && hasTopicTreeData;
  const tagsCount =
    ADMINISTRATION_FUNCTIONS.TAGS && (contentItemsLoading ? '—' : collectUniqueTagLabels(contentItems).size);

  const cardDescription = t('administrationPage.cardDescription');

  return (
    <Page className="administration-page" title={t('administrationPage.title')}>
      <Breadcrumb data={[{ title: t('administrationPage.title') }]} />
      <div className="administration-page__container container container--narrow">
        <h1 className="administration-page__heading">{t('administrationPage.title')}</h1>
        <div className="administration-page__grid">
          <div className="administration-page__grid-item">
            <Link className="administration-page__card" to="/administration/topics">
              <div className="administration-page__card-top">
                <span
                  className={`administration-page__card-count${
                    shouldDimTopicsCount ? ' administration-page__card-count--loading' : ''
                  }`}>
                  {topicsCount}
                </span>
                <span className="administration-page__card-icon" aria-hidden>
                  <TopicsIcon width={32} height={32} />
                </span>
              </div>
              <h2 className="administration-page__card-title">{t('administrationPage.topicsTitle')}</h2>
              <p className="administration-page__card-text">{cardDescription}</p>
            </Link>
          </div>
          {ADMINISTRATION_FUNCTIONS.TAGS ? (
            <div className="administration-page__grid-item">
              <Link className="administration-page__card" to="/administration/tags">
                <div className="administration-page__card-top">
                  <span className="administration-page__card-count">{tagsCount}</span>
                  <span className="administration-page__card-icon" aria-hidden>
                    <TagsIcon width={32} height={32} />
                  </span>
                </div>
                <h2 className="administration-page__card-title">{t('administrationPage.tagsTitle')}</h2>
                <p className="administration-page__card-text">{cardDescription}</p>
              </Link>
            </div>
          ) : null}
        </div>
      </div>
    </Page>
  );
}
